/* Casca do app: barra lateral, submenu, caminho no topo, empresa e selo do ambiente. */

import { CFG, isApi } from '../core/config';
import { state } from '../core/estado';
import { esc } from '../core/formato';
import { $, ic } from './dom';

interface ItemMenu {
  id: string;
  l: string;
}

export interface Secao {
  id: string;
  icon: string;
  label: string;
  /** Página aberta ao clicar na seção. */
  home: string;
  grupos?: { t: string; items: ItemMenu[] }[];
  /** Fica no rodapé da barra lateral. */
  rodape?: boolean;
  /** Só aparece para quem pode lançar dados no CNPJ escolhido. */
  soQuemLanca?: boolean;
}

export const NAV: Secao[] = [
  { id: 'painel', icon: 'i-grid', label: 'Painel', home: 'visao' },
  {
    id: 'analise', icon: 'i-chart', label: 'Análise', home: 'categorias',
    grupos: [{
      t: 'ANÁLISE DO INVENTÁRIO',
      items: [
        { id: 'categorias', l: 'Por categoria' },
        { id: 'evolucao', l: 'Evolução mensal' },
        { id: 'obras', l: 'Por obra' },
        { id: 'fornecedores', l: 'Fornecedores e materiais' },
      ],
    }, {
      t: 'GRÁFICOS PERSONALIZADOS',
      items: [
        { id: 'montar', l: 'Monte seu gráfico' },
        { id: 'graficos', l: 'Meus gráficos' },
      ],
    }],
  },
  {
    id: 'emissoes', icon: 'i-cloud', label: 'Emissões', home: 'lancar', soQuemLanca: true,
    grupos: [
      {
        t: 'LANÇAR EMISSÕES',
        items: [
          { id: 'lancar', l: 'Lançamento manual' },
          { id: 'planilha', l: 'Planilha padrão' },
          { id: 'personalizada', l: 'Planilha personalizada' },
          { id: 'documentos', l: 'Processar documentos' },
        ],
      },
      { t: 'ACOMPANHAMENTO', items: [{ id: 'envios', l: 'Meus envios' }] },
    ],
  },
  { id: 'simulador', icon: 'i-calc', label: 'Simulador de cálculo', home: 'calcular' },
  { id: 'relatorios', icon: 'i-file', label: 'Relatórios', home: 'lista' },
  { id: 'config', icon: 'i-gear', label: 'Conta e dados', home: 'geral', rodape: true },
];

/** Na demonstração todos lançam; com dados reais, só quem tem permissão no CNPJ (vem do catálogo). */
export const podeLancar = (): boolean => !isApi() || Boolean(state.cat?.empresa.pode_lancar);

export const secaoVisivel = (s: Secao): boolean => !s.soQuemLanca || podeLancar();

export const secao = (id: string) => NAV.find((s) => s.id === id);

export function renderRail(): void {
  const botao = (s: Secao) => `<a class="rail-btn ${state.sec === s.id ? 'is-active' : ''}" href="#/${s.id}" aria-label="${s.label}">
        ${ic(s.icon)}<span class="tip">${s.label}</span></a>`;
  $('#rail').innerHTML = `<div class="rail-logo"><img src="./favicon-claro.png" alt="ZNIT"></div>${
    NAV.filter((s) => !s.rodape && secaoVisivel(s)).map(botao).join('')}<div class="rail-spacer"></div>${NAV.filter((s) => s.rodape).map(botao).join('')}`;
}

export function renderSubnav(): void {
  const s = secao(state.sec);
  const el = $('#subnav');
  if (!s?.grupos) {
    el.style.display = 'none';
    return;
  }
  el.style.display = '';
  el.innerHTML = s.grupos.map((g) => `<h4>${g.t}</h4>${g.items.map((i) => `
    <a class="sub-link ${state.page === i.id ? 'is-active' : ''}" href="#/${s.id}/${i.id}"><span>${i.l}</span></a>`).join('')}`).join('');
}

export function renderCrumbs(tituloExtra?: string): void {
  const s = secao(state.sec);
  const item = s?.grupos?.flatMap((g) => g.items).find((i) => i.id === state.page);
  const partes = [s ? s.label : 'Painel'];
  if (item) partes.push(item.l);
  if (tituloExtra) partes.push(tituloExtra);
  $('#crumbs').innerHTML = partes.map((p, i) => `<span class="${i < partes.length - 1 ? 'dim' : ''}">${p}</span>`).join('<span class="sep">/</span>');
}

const cnpjTela = (c: string) => (c.length === 14 ? c.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : c);

/** Empresa escolhida no topo (no modo demonstração, o usuário fictício) e o seletor de CNPJs. */
export function renderQuem(): void {
  const empresa = isApi() ? state.cat?.empresa : undefined;
  const pessoa = isApi() ? CFG.usuario?.nome || CFG.usuario?.email || '' : '';
  $('#topWho').innerHTML = empresa
    ? `<b>${esc(empresa.nome)}</b><span>${pessoa ? `${esc(pessoa)} · ` : ''}CNPJ ${esc(cnpjTela(empresa.cnpj))}</span>`
    : isApi() ? `<b>${esc(pessoa)}</b><span>ZNIT</span>` : '<b>Usuário de demonstração</b><span>ZNIT</span>';
  const iniciais = (t: string) => t.split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((p) => p[0]).join('').toUpperCase();
  $('#topAvatar').textContent = isApi() ? iniciais(pessoa || empresa?.nome || 'ZN') : 'UD';

  const empresas = (isApi() && state.cat?.empresas) || [];
  const seletor = $('#empresaSel');
  seletor.hidden = empresas.length < 2;
  $<HTMLSelectElement>('#empresaSelect').innerHTML = empresas.map((e) =>
    `<option value="${esc(e.cnpj)}" ${e.cnpj === (empresa?.cnpj || CFG.cnpj) ? 'selected' : ''}>${e.nome === cnpjTela(e.cnpj) ? '' : `${esc(e.nome)} · `}${esc(cnpjTela(e.cnpj))}</option>`).join('');
}

export function renderEnv(): void {
  const p = $('#envPill');
  p.classList.toggle('live', isApi());
  p.textContent = isApi() ? 'Dados reais' : 'Ambiente de demonstração';
}
